import React from "react";

import { Button } from "@mui/material";
import ChatIcon from "@mui/icons-material/Chat";
import CommentsDialog from "../../../../../../../../../components/Dialogs/CommentsDialog";
import { useBidContext } from "../../Bid.context";

export default function ChatBtn({ mrqData, col, setOpenChatVendorIndex }) {
  const [open, setOpen] = React.useState(false);
  const { bidData } = useBidContext();
  const vendors = mrqData?.vendors || [];

  const openChatWithVendor = (vendorName) => {
    const selectedIndex = vendors.findIndex((v) => v.name === vendorName);
    const selectedVendor = vendors.find((v) => v.name === vendorName);

    console.log({ bidData, mrqData });
    setOpen(true);
    setOpenChatVendorIndex(selectedIndex);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        onClick={() => openChatWithVendor(col.id)}
        variant="contained"
        endIcon={<ChatIcon />}
        sx={{ borderTopRightRadius: 0, borderBottomRightRadius: 0 }}
      >
        Chat
      </Button>

      <CommentsDialog
        open={open}
        handleClose={onClose}
        parentId={
          mrqData?.id + "_" + vendors.find((v) => v.name === col?.id)?.id
        }
        parentType="bid"
      />
    </>
  );
}
